import { Serializers, serializerExtensions } from "@megaron/serializers";

export const signalSubjectDocTypes = [
  "invoice-thread",
  "customer",
  "invoice-draft",
  "support-ticket",
  "fulfillment-order",
] as const;

export type SignalSubjectDocType = (typeof signalSubjectDocTypes)[number];

const legacySignalSubjectDocTypeByValue: Record<string, SignalSubjectDocType> = {
  draft: "invoice-draft",
  ticket: "support-ticket",
};

export const normalizeSignalSubjectDocType = (value: string): string =>
  legacySignalSubjectDocTypeByValue[value] ?? value;

const signalSubjectDocTypeCoreSerializer = Serializers.stringOneOf(...signalSubjectDocTypes);

export const signalSubjectDocTypeSerializer = {
  serialize: signalSubjectDocTypeCoreSerializer.serialize,
  deserialize: (raw: unknown) =>
    signalSubjectDocTypeCoreSerializer.deserialize(
      typeof raw === "string" ? normalizeSignalSubjectDocType(raw) : raw,
    ),
  ...serializerExtensions(),
};

export const signalSubjectDocTypeFromString = (value: string, context: string): SignalSubjectDocType => {
  const result = signalSubjectDocTypeSerializer.deserialize(value);
  if (result.isFailure) {
    throw new Error(`Unknown signal subject doc type in ${context}: ${value}`);
  }
  return result.value;
};
